import { Link } from 'react-router-dom';
import '../App.css';
import Header from '../components/Header';
import { Helmet } from "react-helmet-async";

function Activities() {
  return (
<>
      <Helmet>
        <title>Care Home Activities & Social Events in Addlestone</title>
        <meta
          name="description"
          content="Life at Rodwell House is rich and varied. From arts and crafts and baking to live performances and outings, we offer a variety ofdaily group activities to keep residents active."
        />
        <link rel="canonical" href="https://www.rodwell.house/activities" />
      </Helmet>

    <div className="page">
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <Header />

      <main id="main-content">
        <section className="content-section activities-page">
          <div className="activities-container">
            <h1>Activities</h1>
          </div>
        </section>

        <section className="content-section activities-intro">
          <div className="section__container">
            <div className="section__text">
              <h2>Vibrant Day Services</h2>
              <p>We offer separate day services in each of our two lounges. We recognise that not every resident benefits from activities for sustained periods of time or in larger groups. Therefore, we schedule these kinds of activities in our South Lounge, whilst concurrently providing shorter, more sensory and therapeutic activities in our North Lounge. This means that every one of our residents can benefit from stimulating activities.</p>
            </div>
            <div className="section__image">
              <img src="/activities-lounge-stock.jpg" alt="Activities lounge" />
            </div>
          </div>
        </section>

        <section className="content-section first-floor-programme">
          <div className="section__container">
            <div className="section__text">
              <h2>South Lounge Programme</h2>
              <p>We offer four main group activities every day – two in the morning and two in the afternoon – in the South Lounge, so that residents can choose the hobbies or entertainment that most excite them. We also give all residents the opportunity to engage in discussion about the day’s current affairs during the daily coffee morning.</p>
            </div>
          </div>
        </section>

        <section className="content-section powerbi-dashboard">
          <div className="powerbi-container">
            <div className="powerbi-ratio">
              <iframe
                title="Rodwell Main Lounge Group Activities Programme"
                width="600"
                height="373.5"
                src="https://app.powerbi.com/view?r=eyJrIjoiMjYwZTgzZDYtNzA2My00MDcyLWE5YzEtZGJkY2MzMDRiN2E1IiwidCI6ImUzNmQ3NWZhLWU4NjItNDAyMC05MzllLTU0YjFiNDQ2NGFlMSJ9"
                frameBorder="0"
                allowFullScreen={true}
              />
            </div>
          </div>
        </section>

        <section className="content-section second-floor-programme">
          <div className="section__container">
            <div className="section__text">
              <h2>North Lounge Programme</h2>
            </div>
          </div>
        </section>

        <section className="content-section powerbi-dashboard">
          <div className="powerbi-container">
            <div className="powerbi-ratio">
              <iframe
                title="Rodwell Sensory Lounge Individual Activities Programme"
                width="600"
                height="373.5"
                src="https://app.powerbi.com/view?r=eyJrIjoiMGI5N2Y3MWItZGY3Ni00ZTcwLTllZDUtNGIxNDQ2MjI1MmNkIiwidCI6ImUzNmQ3NWZhLWU4NjItNDAyMC05MzllLTU0YjFiNDQ2NGFlMSJ9"
                frameBorder="0"
                allowFullScreen={true}
              />
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        <section className="footer__enquiry">
          <div className="footer__enquiry-container">
            <Link to="/contact-us" className="footer__enquiry-link">
              Enquire about Graham Care <span className="footer__arrow">▶</span>
            </Link>
          </div>
        </section>
        <div className="footer__container">
          <section className="contact-section">
            <div className="contact-section__content">
              <p>Graham Care Ltd, KT15 1HH</p>
              <p>Copyright © Graham Care Ltd</p>
            </div>
          </section>
        </div>
      </footer>
    </div>
    </>
  );
}

export default Activities;
